import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const USER_DEPARTMENT_URL = 'user/departments'

const errors = createHandbookResponseErrors('отдел', 'отделов')

export const UserDepartmentApi = createNewHandbookApi(USER_DEPARTMENT_URL, errors)
